module.exports = __webpack_public_path__ + "components/MapControl/svg/Apteka.svg?a6b38f50";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Apteka.svg
// module id = 2014
// module chunks = 0